import { take, put } from "redux-saga/effects";
import { LOGIN, loginActions } from "src/redux/actions/auth";

// services
import { setToken, setRefreshToken, setTokenExpDate } from "src/services/localStorage";
import { login } from "src/services/http/user";

// types
import { LoginRequestTypes, LoginResponseTypes } from "src/redux/actions/auth/types";

import * as Effects from "redux-saga/effects";
const call: any = Effects.call;

function* watchLoginRequest() {
  while (true) {
    const { payload }: IActionType<LoginRequestTypes> = yield take(LOGIN.REQUEST);

    const { onError, onSuccess, ...restPayload } = payload as LoginRequestTypes;

    try {
      const result: LoginResponseTypes = yield call(login, restPayload);

      setToken(result.access_token);
      setRefreshToken(result.refresh_token);
      setTokenExpDate(result[".expires"]);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      yield put(loginActions.success({ access_token: result.access_token, userId: result.UserId }));
      onSuccess();
    } catch (e: unknown) {
      const message =
        (e as { error?: string })?.error ?? (e instanceof Error ? e.message : "Something went wrong, try again later");
      onError(message);
      yield put(loginActions.error({ error: message }));
    }
  }
}

export default watchLoginRequest;
